module.exports = __webpack_public_path__ + "img/A02.1b03dbdb.jpg";